let donation = '0';
const currentTotal = document.querySelector('#CurrentOrderTotalValue') as HTMLInputElement;
const totals = document.querySelector('#DonationTotal') as HTMLElement;
const donationInput = document.querySelector('#SuggestedContribution') as HTMLInputElement;
const monthlyRadioButton = document.querySelector('#SelectedRenewalOption_IsMonthly') as HTMLInputElement;

const oneTimeRadioButton = document.querySelector('#SelectedRenewalOption_IsOneTime') as HTMLInputElement;
var currencyInput = document.getElementById('SuggestedContribution') as HTMLInputElement;

var hiddenAlternateSuggestedContribution = document.getElementById('HiddenAlternateSuggestedContribution') as HTMLInputElement;
var hiddenSuggestedContribution = document.getElementById('HiddenSuggestedContribution') as HTMLInputElement;


export const donationInterruptPage = () => {
    if (donationInput != null) {
        donationInput.addEventListener('change', getDonationWithTotal);
    }
    if (monthlyRadioButton != null) {
        monthlyRadioButton.addEventListener('change', handleRadioButtonChange);
    }
    if (oneTimeRadioButton != null) {
        oneTimeRadioButton.addEventListener('change', handleRadioButtonChange);
    }
}

const getDonationWithTotal = (e) => {
    donation = donationInput.value;
    const donationValue = parseFloat(donation);
    try {
        const currencyFormatter = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
        });

        if (isNaN(donationValue)) {
            totals.innerHTML = currencyFormatter.format(parseFloat(currentTotal.value));
        } else {
            const updatedTotal = currencyFormatter.format(parseFloat(currentTotal.value) + donationValue);
            totals.innerHTML = updatedTotal;
        }
    } catch (ex) {
        console.error(`Error: ${ex}`);
    }

    if (!isNaN(donationValue)) {
        donationInput.value = donationValue.toFixed(2);
    } else {
        donationInput.value = "0";
    }
};

const handleRadioButtonChange = (e) => {
    if (monthlyRadioButton.checked) {
        currencyInput.value = hiddenAlternateSuggestedContribution.value;
    } else if (oneTimeRadioButton.checked) {
        currencyInput.value = hiddenSuggestedContribution.value;
    }
    const newDonationInput = document.querySelector('#SuggestedContribution') as HTMLInputElement;
    if (newDonationInput != null) {
        newDonationInput.addEventListener('change', getDonationWithTotal);
    }

    newDonationInput.dispatchEvent(new Event('change'));
};
